export default __webpack_public_path__ + "static/media/experience.7f08b1b3.svg";